<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_223_1199)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 21.2545C7.94118 21.2545 4.24551 17.5588 4.24551 13C4.24551 8.44118 7.94118 4.74551 12.5 4.74551C17.0588 4.74551 20.7545 8.44118 20.7545 13C20.7545 17.5588 17.0588 21.2545 12.5 21.2545ZM2.49551 13C2.49551 7.47468 6.97468 2.99551 12.5 2.99551C18.0253 2.99551 22.5045 7.47468 22.5045 13C22.5045 18.5253 18.0253 23.0045 12.5 23.0045C6.97468 23.0045 2.49551 18.5253 2.49551 13ZM12.6742 7.28488C13.1678 7.28488 13.5679 7.68498 13.5679 8.17854V12.1063H17.4957C17.9892 12.1063 18.3893 12.5064 18.3893 13C18.3893 13.4935 17.9892 13.8936 17.4957 13.8936L13.5679 13.8936V17.8214C13.5679 18.315 13.1678 18.7151 12.6742 18.7151C12.1807 18.7151 11.7806 18.315 11.7806 17.8214V13.8936H7.85279C7.35924 13.8936 6.95914 13.4935 6.95914 13C6.95914 12.5064 7.35924 12.1063 7.85279 12.1063L11.7806 12.1063V8.17854C11.7806 7.68499 12.1807 7.28488 12.6742 7.28488Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_223_1199">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
